<template>
  <v-container>
    <h1>Сметы</h1>
    <v-data-table
      :headers="tblHeaders"
      :items="items"
      item-key="_id"
      class="elevation-1"
      :loading="loadingList"
      loading-text="Данные загружаются... Пожалуйста, подождите."
      :search="search"
    >
      <template v-slot:top>
        <v-row class="pl-4 pr-4">
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="search"
              placeholder="Введите данные для поиска"
              class="mr-4"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              v-model="filter"
              label="Фильтр"
              :items="fltItems"
            ></v-select>
          </v-col>
        </v-row>
        
      </template>
      <template v-slot:[`item.id`]="{item}">
        <router-link :to="{ name: 'SingleEstimate', params: { id: item._id } }">
          {{ item.id }}
        </router-link>
      </template>
      <template v-slot:[`item.owner`]="{item}">
        <template v-if="item.ownerUser">{{item.owner}}</template>
        <template v-else>
          Клиент 
          <customer-card :id="item.ownerCustomer.id"></customer-card>
        </template>
      </template>
      <template v-slot:[`item.actions`]="{item}">
        <delete-button
          v-if="isAdmin"
          :id="item._id"
          objName="смету"
          :deleteFunc="$store.dispatch"
          funcParam="estimates/delete"
        >
          Название для сайта: {{ item.name }} <br>
        </delete-button>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import CustomerCard from '../customers/CustomerCard';

export default {
  components: {
    CustomerCard
  },

  data() {
    return {
      search: '',
      filter: '',
      fltItems: [
        {
          text: 'Все сметы',
          value: ''
        },
        {
          text: 'Клиентские',
          value: 'customer'
        },
        {
          text: 'Пользовательские',
          value: 'user'
        },
      ],
      tblHeaders: [
        {
          text: '№',
          value: 'id'
        },
        {
          text: 'Название для сайта',
          value: 'name'
        },
        {
          text: 'Адрес',
          value: 'objectEntity.addressPublic'
        },
        {
          text: 'Владелец',
          value: 'owner'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ]
    }
  },
  
  computed: {
    ...mapState('estimates', ['estimates', 'loadingList']),
    ...mapGetters('users', ['isAdmin']),
    items() {
      return this.estimates.map(x => ({
        ...x,
        owner: x.ownerUser ? x.ownerUser.fullName : 'Клиент с сайта'
      })).filter(x => {
        if (!this.filter) return true;
        if (this.filter == 'customer') return x.ownerCustomer
        else return x.ownerUser; 
      });
    }
  }
}
</script>